import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H2 } from 'UIComponents/elements/headings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function RefundSyncedPaymentConfirmationModal({
  paymentSource,
  processorType,
  onConfirm,
  onCancel
}) {
  const getDescription = () => {
    const key = `cardPaymentHighlight.paymentHighlight.sidebarActions.refundPayment.syncedPaymentModal.${paymentSource === 'INTEGRATION' ? 'bodyExternalSource' : 'bodyHubSpotSource'}.${processorType}`;
    if (isValidI18nKey(key)) {
      return /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx("p", {
          className: "m-bottom-6",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: key
          })
        })
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    "data-test-id": "refund-synced-payment-confirmation-modal",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        className: "text-left m-bottom-8",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.refundPayment.syncedPaymentModal.title"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onCancel
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsxs("div", {
        className: "text-left",
        children: [getDescription(), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.refundPayment.syncedPaymentModal.warning"
        })]
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: onConfirm,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.refundPayment.syncedPaymentModal.continueText"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary-light",
        onClick: onCancel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.refundPayment.syncedPaymentModal.cancelText"
        })
      })]
    })]
  });
}
export default RefundSyncedPaymentConfirmationModal;